var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SortableListAdder',{attrs:{"invalid":_vm.invalid},on:{"add":_vm.add}},[_c('LeaderboardForm',{staticClass:"form",attrs:{"ranges":_vm.ranges},model:{value:(_vm.toAdd),callback:function ($$v) {_vm.toAdd=$$v},expression:"toAdd"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }